document.addEventListener('click', async (event) => {
  const copyButton = event.target.closest('[data-adoc-copy-link]');

  if (copyButton) {
    const label = copyButton.textContent;

    try {
      await navigator.clipboard.writeText(copyButton.dataset.shareUrl || window.location.href);
      copyButton.textContent = 'Enlace copiado';
      setTimeout(() => {
        copyButton.textContent = label;
      }, 1800);
    } catch {
      window.prompt('Copia el enlace del producto', copyButton.dataset.shareUrl || window.location.href);
    }

    return;
  }

  document.querySelectorAll('.adoc-pdp-share[open]').forEach((shareMenu) => {
    if (!shareMenu.contains(event.target)) shareMenu.open = false;
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('.adoc-pdp-share[open]').forEach((shareMenu) => {
    shareMenu.open = false;
  });
});
